export default "__VITE_ASSET__EtW8yGK6__ 400w, __VITE_ASSET__oIntg_4p__ 800w, __VITE_ASSET__CtuE2ou9__ 1024w";